import * as React from 'react';
import Section from '../components/Section';

import { Image, Row, Col, Card, Statistic } from 'antd'; 

import fisk from './media/fisk.jpg';

export default function Boats() {

    var prices = (
        <Card title="Prisar fiskekort for Hornindalsvatnet" bordered={false}>
            <Row gutter={[32,32]}>
                <Col xs={12} lg={8}><Statistic title="Døgnkort" value="50,-" /></Col>
                <Col xs={12} lg={8}><Statistic title="Sesongkort" value="300,-"/></Col>
                <Col xs={24} lg={8}><Statistic title="Årlig forvaltningskort" value="50,-" /></Col>
            </Row>
        </Card>
    );

    return (
        <Section id="fishing" title="Fiske">
            <Row gutter={16}>
                <Col xs={24} lg={16}>
                    <p>Frå Nesjartun har du god tilgang til fiske både i vatn, elv og sjø. Vi sel fiskekort for Hornindalsvatnet og øvre del av Eidselva, sone Nor. I tillegg til fiskekort må du også kjøpe årlig forvaltningskort på <a href="elveguiden.no" target="_blank">elveguiden.no</a> (gratis for dei under 16 år, men må registrerast).</p>
                    <p>For nærmare info om laksefiske i eidselva sjå <a href="www.eidselva.no" target="_blank">eidselva.no</a></p>
                    {prices}
                </Col>
                <Col xs={0} lg={8}>
                    <Image src={fisk} preview={false} style={{ marginBottom: "16px" }} width="100%"/>
                </Col>
            </Row>
        </Section>
    );
}